import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { LanguageProvider } from "./context/languageContext"; // ✅ add this
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId="477377377882-vts6jqgv68q953bd0q3r3tlgguhec6va.apps.googleusercontent.com">
    <LanguageProvider>   {/* ✅ wrap here */}
      <App />
    </LanguageProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();